import type { DatasetIconProps } from "./DatasetIcon.type";

import { RiImage2Fill, RiImage2Line } from "react-icons/ri";

const ImageIcon = ({ filled }: DatasetIconProps) => {
  return filled ? <RiImage2Fill /> : <RiImage2Line />;
};

export default ImageIcon;
